import { Spinner, Stack } from '@chakra-ui/react';
import MainCard from '../../../../components/MainCard/Index';
import { useGetProofLocation } from '../../../../services/hooks/ProofLocation/useGetProofLocation';
import ProofLocationCard from '../../../../components/ProofLocationCard/ProofLocationCard';
import { useLocation } from 'react-router-dom';
import { useContext } from 'react';
import { ContextAuth } from '../../../../contexts/Authentication';
import AllocationInfoMobilePage from '../Mobile/AllocationInfo';

const ProofLocationCandidateArea: React.FC = () => {
  const { isMobile } = useContext(ContextAuth);
  const registrationId = useLocation().pathname.split('/')[3];
  const proofLocationData = useGetProofLocation(registrationId);
  const widhtLabel = ['', '', '', '', ''];
  const boxDisplay = ['', '', 'flex', 'flex', 'flex'];
  const boxGap = ['', '', '5px', '5px', '5px'];

  if (isMobile) return <AllocationInfoMobilePage title="Local de prova" data={proofLocationData.data} />;

  return (
    <MainCard title="ÁREA DO CANDIDATO " subtitle="- LOCAL DE PROVA">
      {proofLocationData?.isLoading ? (
        <Stack align="center" justify="center">
          <Spinner />
        </Stack>
      ) : (
        <ProofLocationCard
          boxDisplay={boxDisplay}
          boxGap={boxGap}
          proofLocationData={proofLocationData?.data}
          widhtLabel={widhtLabel}
          showDownloadButton={true}
        />
      )}
    </MainCard>
  );
};

export default ProofLocationCandidateArea;
